"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const models_1 = require("../models");
const request_1 = require("../requests/request");
const album_1 = require("../models/album");
const tag_1 = require("../models/tag");
const curated_1 = require("../models/curated");
const curated_set_1 = require("../models/curated_set");
const artist_1 = require("../models/artist");
const search_suggestion_1 = require("../models/search_suggestion");
const jsonparser_1 = require("../requests/jsonparser");
const podcast_1 = require("../models/podcast");
const podcast_response_1 = require("../models/podcast_response");
const bpmplaylist_response_1 = require("../models/bpmplaylist_response");
var RemixQueryOptions;
(function (RemixQueryOptions) {
    RemixQueryOptions["All"] = "all";
    RemixQueryOptions["Hide"] = "hide";
    RemixQueryOptions["Only"] = "only";
})(RemixQueryOptions = exports.RemixQueryOptions || (exports.RemixQueryOptions = {}));
var SortByQueryOptions;
(function (SortByQueryOptions) {
    SortByQueryOptions["DateDes"] = "date_des";
    SortByQueryOptions["DateAsc"] = "date_asc";
    SortByQueryOptions["ArtistDesc"] = "artisc_desc";
    SortByQueryOptions["ArtisAsc"] = "artist_asc";
    SortByQueryOptions["TitleDesc"] = "title_desc";
    SortByQueryOptions["TitleAsc"] = "title_asc";
    SortByQueryOptions["BPMDesc"] = "bpm_desc";
    SortByQueryOptions["BPMAsc"] = "bpm_asc";
})(SortByQueryOptions = exports.SortByQueryOptions || (exports.SortByQueryOptions = {}));
var MediaContentType;
(function (MediaContentType) {
    MediaContentType["Video"] = "video";
    MediaContentType["Audio"] = "audio";
})(MediaContentType = exports.MediaContentType || (exports.MediaContentType = {}));
class API {
    static getLiveStatus() {
        let apiRequest = new request_1.AuthenticatedRequest('/live/status', request_1.HTTPMethod.GET, request_1.APIVersion.v3_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getVOD() {
        let apiRequest = new request_1.AuthenticatedRequest('/video-on-demand', request_1.HTTPMethod.GET, request_1.APIVersion.v3_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static openAPIlink(link) {
        let apiRequest = new request_1.AuthenticatedRequest('/banners/link', request_1.HTTPMethod.GET, request_1.APIVersion.v3_0, { link });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * get Banners
     */
    static getBanner() {
        let apiRequest = new request_1.AuthenticatedRequest('/banners', request_1.HTTPMethod.GET, request_1.APIVersion.v3_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the download url for an media object
     * @returns {Promise<{url: string>} The Promise contains an APIError if rejected (DownloadLimitReachedError)
     */
    static downloadMedia(media_id, crate, from, options) {
        let apiRequest = new request_1.AuthenticatedRequest('/media/' + media_id + '/download', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({ crate: crate ? 'true' : 'false', from }, options));
        apiRequest.preventNotVerifiedHandler = true;
        apiRequest.preventInvalidSubscriptionHandler = true;
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the recommendations for a media object
     * @returns {Promise<{artist?: Artist, songs: Album[]}>} The Promise contains an APIError if rejected
     */
    static getMediaRecommendations(media_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/media/' + media_id + '/artistreleases', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the artists for a media object
     * @returns {Promise<Artist[]>} The Promise contains an APIError if rejected
     */
    static getMediaArtists(media_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/media/' + media_id + '/artists', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(artist_1.Artist).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the albums for a artist
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getArtistAlbums(contentType, artist, options, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/artist/' + encodeURIComponent(artist) + '/albums/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({
            limit: paging.limit,
            skip: paging.skip
        }, options));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
    * Fetches the top downloads
    * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
    */
    static getDownloadHistory(contentType, filter, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/download-history/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({}, filter, paging));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches the top downloads
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getTopDownloads(contentType, options, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/topdownloads/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({
            limit: paging.limit,
            skip: paging.skip
        }, options));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches the top downloads
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getTopDownloadsPerCategory(contentType, options) {
        let apiRequest = new request_1.AuthenticatedRequest('/topdownloads/' + contentType + '/perCategory', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, options);
        return apiRequest.send(album_1.Album).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the top downloads for a given category
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getTopDownloadsForCategory(contentType, categorySlug, options, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/categories/' + categorySlug + '/topdownloads/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({
            limit: paging.limit,
            skip: paging.skip
        }, options));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches all RadioChartCategoroies
     * @returns {Promise<RadioChartCategory[]>} The Promise contains an APIError if rejected
     */
    static getRadioChartCategories() {
        let apiRequest = new request_1.AuthenticatedRequest('/radiochartcategories', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.RadioChartCategory).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the radio charts
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getRadioCharts(contentType, options, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/radiocharts/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({
            limit: paging.limit,
            skip: paging.skip
        }, options));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches the new releases
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getNewReleases(contentType, options, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/newreleases/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({
            limit: paging.limit,
            skip: paging.skip
        }, options));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches the new releases
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getNewReleasesPerCategory(contentType, options) {
        let apiRequest = new request_1.AuthenticatedRequest('/newreleases/' + contentType + '/perCategory', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, options);
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches the new releases
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getNewReleasesForCategory(contentType, categorySlug, options, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/categories/' + encodeURIComponent(categorySlug) + '/newreleases/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({
            limit: paging.limit,
            skip: paging.skip
        }, options));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches the search results
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getSearch(contentType, criteria, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/search/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign(criteria, {
            limit: paging.limit,
            skip: paging.skip
        }));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches the combined bucket search results
     * @returns {Promise<>} The Promise contains an APIError if rejected
     */
    static getContentSearch(query, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/search-content', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({ search: query }, {
            limit: paging.limit,
            skip: paging.skip
        }));
        return apiRequest.send().then((response) => {
            let data = {
                news: response.data.news.map(i => jsonparser_1.default.deserialize(models_1.NewsFeedItem, i)),
                albums: response.data.albums.map(i => jsonparser_1.default.deserialize(album_1.Album, i)),
                sets: jsonparser_1.default.deserialize(curated_set_1.CuratedSet, response.data.sets),
            };
            return data;
        });
    }
    /**
     * Fetches the playlists
     * @returns {Promise<CuratedSet>} The Promise contains an APIError if rejected
     */
    static getBPMPlaylists(search, onlyFeatured) {
        let apiRequest = new request_1.AuthenticatedRequest('/bpm_playlists', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, { search, onlyFeatured });
        return apiRequest.send(bpmplaylist_response_1.BPMPlaylistResponse).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the podcasts
     * @returns {Promise<CuratedSet>} The Promise contains an APIError if rejected
     */
    static getPodcasts(search) {
        let apiRequest = new request_1.AuthenticatedRequest('/podcasts', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, { search });
        return apiRequest.send(podcast_response_1.PodcastResponse).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the curated sets
     * @returns {Promise<CuratedSet>} The Promise contains an APIError if rejected
     */
    static getCuratedSets(search) {
        let apiRequest = new request_1.AuthenticatedRequest('/curated_sets', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, { search });
        return apiRequest.send(curated_set_1.CuratedSet).then((response) => {
            return response.data;
        });
    }
    /**
    * Fetches the featured curated sets
    * @returns {Promise<CuratedSet>} The Promise contains an APIError if rejected
    */
    static getFeaturedCuratedSets() {
        let apiRequest = new request_1.AuthenticatedRequest('/curated_sets/featured', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(curated_1.Curated).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the podcast
     * @returns {Promise<Curated>} The Promise contains an APIError if rejected
     */
    static getPodcastSlug(slug) {
        let apiRequest = new request_1.AuthenticatedRequest('/podcasts/slug/' + slug, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(podcast_1.Podcast).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the playlist
     * @returns {Promise<Curated>} The Promise contains an APIError if rejected
     */
    static getBPMPlaylistBySlug(slug) {
        let apiRequest = new request_1.AuthenticatedRequest('/bpm_playlists/slug/' + slug, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(models_1.BPMPlaylist).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the curated set
     * @returns {Promise<Curated>} The Promise contains an APIError if rejected
     */
    static getCuratedBySlug(slug) {
        let apiRequest = new request_1.AuthenticatedRequest('/curated_sets/slug/' + slug, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(curated_1.Curated).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the songs for a podcast
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getPodcast(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/podcasts/' + id, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(album_1.Album).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the songs for a playlist
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getBPMPlaylist(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/bpm_playlists/' + id, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(album_1.Album).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the songs for a curated set
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getCuratedSet(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/curated_sets/' + id, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(album_1.Album).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the songs for a curated set
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getPlaybackInfo(mediaId, from, options) {
        let apiRequest = new request_1.AuthenticatedRequest('/media/' + mediaId + '/play', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({}, options, { from }));
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Sets secure cookies to access media
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    static getCloudfrontCookie() {
        let apiRequest = new request_1.AuthenticatedRequest('/media/cookie', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }
    /**
     * Fetches the browse section
     * @param contentType
     * @param paging
     * @param categorySlug
     */
    static getBrowse(contentType, options, paging) {
        let apiRequest = new request_1.AuthenticatedRequest('/browse/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, Object.assign({
            limit: paging.limit,
            skip: paging.skip
        }, options));
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    /**
     * Fetches the categories for a given content-type
     * @returns {Promise<Category[]>} The Promise contains an APIError if rejected
     */
    static getCategories(contentType, scope) {
        let apiRequest = new request_1.AuthenticatedRequest(contentType ? '/categories/' + contentType : '/categories', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, scope ? { scope: scope } : undefined);
        return apiRequest.send(models_1.Category).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches all keys
     * @returns {Promise<string[]>} The Promise contains an APIError if rejected
     */
    static getKeys() {
        let apiRequest = new request_1.AuthenticatedRequest('/keys', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, undefined);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the sub genres for a given category
     * @returns {Promise<Category[]>} The Promise contains an APIError if rejected
     */
    static getSubGenres(categorySlug, contentType) {
        let apiRequest = new request_1.AuthenticatedRequest((contentType ? '/categories/' + contentType : '/categories') + '/' + categorySlug + '/subgenres', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, undefined);
        return apiRequest.send(models_1.Genre).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the top10
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getTop10(contentType) {
        let apiRequest = new request_1.AuthenticatedRequest('/top10/' + contentType, request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(album_1.Album).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the sub genres for a given category
     * @returns {Promise<Genre[]>} The Promise contains an APIError if rejected
     */
    static getAllSubGenres(contentType) {
        let apiRequest = new request_1.AuthenticatedRequest('/subgenres' + (contentType ? ('/' + contentType) : ''), request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, undefined);
        return apiRequest.send(models_1.Genre).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches the sub genres for a given category
     * @returns {Promise<Genre[]>} The Promise contains an APIError if rejected
     */
    static getTop5Genres(contentType) {
        let apiRequest = new request_1.AuthenticatedRequest('/subgenres' + (contentType ? ('/' + contentType) : ''), request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, { top5: true });
        return apiRequest.send(models_1.Genre).then((response) => {
            return response.data;
        });
    }
    /**
     * Fetches all Tags required for the search UI
     * @returns {Promise<Tag[]>} The Promise contains an APIError if rejected
     */
    static getTags() {
        let apiRequest = new request_1.AuthenticatedRequest('/tags', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(tag_1.Tag).then((response) => {
            return response.data;
        });
    }
    /**
     * Get search suggestions based on the entered term
     * @returns {Promise<SearchSuggestion[]>} The Promise contains an APIError if rejected
     */
    static getSearchSuggestions(term) {
        let apiRequest = new request_1.AuthenticatedRequest('/suggest', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2, { term });
        return apiRequest.send(search_suggestion_1.SearchSuggestion).then((response) => {
            return response.data;
        });
    }
    /**
     * Reports a album artowrk as inappropriate. Only allowed as admin!
     * @returns {Promise<void>} The Promise contains an APIError if rejected
     */
    static reportAlbumArtwork(album_id) {
        let apiRequest = new request_1.AuthenticatedRequest('/album/' + album_id + '/cover_art', request_1.HTTPMethod.DELETE, request_1.APIVersion.v1_2);
        return apiRequest.send().then((response) => {
            return void 0;
        });
    }
    /**
     * Fetches the featured albums
     * @returns {Promise<Album[]>} The Promise contains an APIError if rejected
     */
    static getFeatured() {
        let apiRequest = new request_1.AuthenticatedRequest('/browse/featured', request_1.HTTPMethod.GET, request_1.APIVersion.v1_2);
        return apiRequest.send(album_1.Album).then((response) => {
            return response;
        });
    }
    static savetempAlbum(album) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/media/temp/save', request_1.HTTPMethod.POST, request_1.APIVersion.v1_0, undefined, album);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getMediaUploadLink(key) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/media/temp/uploadLink', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { key });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static transcodeMedia(type, key) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/media/temp/transcode/' + type, request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { key });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static parseAudioInformation(key, album_name) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/media/temp/parse/audio', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { key, album_name });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static parseVideoInformation(key, album_name) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/media/temp/parse/video', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { key, album_name });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static updateMedia(album_id, media_id, data) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/album/' + album_id + '/media/' + media_id, request_1.HTTPMethod.PUT, request_1.APIVersion.v1_0, undefined, data);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static checkMediaFileExisting(key, lastModified) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/media/temp/checkFile', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { key, lastModified });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static approveAlbum(album) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/album/' + album.id + '/approve', request_1.HTTPMethod.PUT, request_1.APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getAlbumByNameAndArtist(name, artist) {
        let apiRequest = new request_1.AuthenticatedRequest('/admin/album/byNameAndArtist', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0, { name, artist });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getAlbumAnalytics(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/bpm-analytics/album/getById/' + id, request_1.HTTPMethod.GET, request_1.APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getAlbumByid(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/album/' + id, request_1.HTTPMethod.GET, request_1.APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static getSimilarAlbums(id) {
        let apiRequest = new request_1.AuthenticatedRequest('/album/' + id + '/similar', request_1.HTTPMethod.GET, request_1.APIVersion.v1_0);
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
    static setAlbumCover(albumIds, image) {
        return Promise.all(albumIds.split(';').map(id => {
            let apiRequest = new request_1.AuthenticatedFileRequest('/admin/album/' + id + '/cover', request_1.HTTPMethod.PUT, request_1.APIVersion.v1_0, undefined, { image });
            return apiRequest.send().then((response) => {
                return response.data;
            });
        })).then(() => {
        });
    }
}
exports.API = API;
